var _style, _circle, _path, _line, _line2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPostureStanding(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 40 40",
    style: {
      enableBackground: "new 0 0 40 40"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:currentColor;}\r\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 20,
    cy: 6.1,
    r: 3.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M24.3,15.8v20.4c0,0,0.3,1.2-1.3,1.8c-0.1,0.1-1.8,0.1-1.8-2s0-8.4,0-8.4s0.4-1.6-1.1-1.6 c-0.3,0.1-1.1,0-1.1,1.8c0,1.8,0,8.1,0,8.1s0.1,2.1-1.6,2.1c-0.2,0-1.5,0.1-1.5-2.4s0-19.9,0-19.9s0.4-1.9-1.1-0.6 c-1.4,1.3-1.1,1-1.1,1s-1.3,0.6-0.3,1.5c0.8,0.8,2.3,2.8,2.3,2.8s1.3,1.3,0.6,2.4c-0.2,0.4-1.2,1.7-2.4,0.4c-1-1.3-4.3-5.6-4.3-5.6 s-0.8-1.3,0.5-2.4s4.3-3.5,4.3-3.5s0.5-0.8,1.9-0.6c1.2,0,1.5,0,1.5,0s0.8,0,1.1,0.9c0.5,0.8,0.7,1.3,0.7,1.3s0.5,1.1,1.1,0.1 s0.7-2.4,2.8-2.2c1.1,0,1.1,0,1.1,0s0.8,0,1.5,0.8c0.7,0.8,4.2,3.7,4.2,3.7s1.5,0.8,0,2.6c-1.5,1.8-3.9,4.9-3.9,4.9 s-1.4,1.5-2.5-0.1c-0.3-0.6-0.4-1.6,1-3c1.4-1.4,2.2-2.7,2.2-2.7s0.7-0.4-0.6-1.3c-1.3-0.8-1.7-1.4-1.7-1.4S24.1,13.7,24.3,15.8z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 15.9,
    y1: 20.2,
    x2: 24.2,
    y2: 20.2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 15.9,
    y1: 22.8,
    x2: 24.3,
    y2: 22.8
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPostureStanding);
export default __webpack_public_path__ + "static/media/PostureStanding.9be3c045f1005a1638f7cbcf42c2d487.svg";
export { ForwardRef as ReactComponent };